import { c as _c } from "react/compiler-runtime";
import { graphql, VariablesOf } from "@/graphql";
import { graphqlClient } from "@/lib/graphql-client";
import { useMutation } from "@tanstack/react-query";
const createPlanSubscriptionMutation = graphql(`
  mutation createPlanSubscription(
    $tier: SubscriptionTier!
    $billingInterval: BillingInterval!
    $promoCode: String
  ) {
    createPlanSubscription(
      tier: $tier
      billingInterval: $billingInterval
      promoCode: $promoCode
    ) {
      id
    }
  }
`);
export type CreatePlanSubscriptionInput = VariablesOf<typeof createPlanSubscriptionMutation>;
export type BillingInterval = CreatePlanSubscriptionInput["billingInterval"];
export type SubscriptionTierResult = CreatePlanSubscriptionInput["tier"];
export type SubscriptionTier = Exclude<SubscriptionTierResult, "ENTERPRISE" | "PRO" | "STARTER">;
export function useCreateStripeCompanySubscription() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
}
async function _temp(input) {
  return graphqlClient.request(createPlanSubscriptionMutation, {
    tier: input.tier,
    billingInterval: input.billingInterval,
    promoCode: input.promoCode
  });
}